var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import { Row, Col, Collapse } from "@riseart/antd-provider";
import { Heading, Link, MediaQuery } from "@riseart/common";
import { raScreenSmMax, raScreenMd } from "@riseart/antd-provider/dist/website/variables.less";
import { footerAccordionCls, footerMenuCls } from "./Footer.less";
var FooterMenu = /* @__PURE__ */ __name(function FooterMenu2(_ref) {
  var items = _ref.items;
  return /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: 0
  }, /* @__PURE__ */ React.createElement(MediaQuery, {
    maxWidth: raScreenSmMax
  }, /* @__PURE__ */ React.createElement(Collapse, {
    accordion: true,
    className: footerAccordionCls
  }, items && items.map(function(column) {
    return /* @__PURE__ */ React.createElement(Collapse.Panel, {
      showArrow: false,
      header: column.name,
      key: column.name
    }, /* @__PURE__ */ React.createElement("ul", null, column.links.map(function(link) {
      return /* @__PURE__ */ React.createElement("li", {
        key: link.href
      }, /* @__PURE__ */ React.createElement(Link, _extends({
        external: !!link.external,
        href: link.href,
        title: link.label,
        type: "light",
        obfuscate: link.obfuscate || false
      }, link.obfuscate && link.obflinkProps ? {
        obflinkProps: link.obflinkProps
      } : null), link.label));
    })));
  }))), /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: raScreenMd
  }, /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    justify: "space-between",
    align: "top",
    className: footerMenuCls
  }, items && items.map(function(column) {
    return /* @__PURE__ */ React.createElement(Col, {
      key: column.name,
      xs: 24,
      md: 8
    }, /* @__PURE__ */ React.createElement(Heading, {
      tag: "p",
      level: "4"
    }, column.name), /* @__PURE__ */ React.createElement("ul", null, column.links.map(function(link) {
      return /* @__PURE__ */ React.createElement("li", {
        key: link.href
      }, /* @__PURE__ */ React.createElement(Link, _extends({
        external: !!link.external,
        href: link.href,
        title: link.label,
        type: "light",
        obfuscate: link.obfuscate || false
      }, link.obfuscate && link.obflinkProps ? {
        obflinkProps: link.obflinkProps
      } : null), link.label));
    })));
  }))));
}, "FooterMenu");
export {
  FooterMenu
};
